document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('social-proof-popup');
  if (!popup) return;

  const closeBtn = popup.querySelector('.social-proof-popup__close');
  const countEl = popup.querySelector('.social-proof-popup__count');

  const productId = popup.dataset.productId;
  const productHandle = popup.dataset.productHandle || `product-${productId}`;
  const storageKey = `socialProofViews_${productHandle}`;

  let hideTimeout = null;
  let repeatInterval = null;

  // -----------------------------------
  // SETTINGS
  // -----------------------------------
  const MIN_UPDATE_DELAY_MS = 5 * 60 * 1000; // 5 min
  const MAX_UPDATE_DELAY_MS = 7 * 60 * 1000; // 7 min
  // -----------------------------------
// TRAFFIC DATA FROM GA4
// -----------------------------------

// Average hourly sessions from GA4
const hourlyTraffic = [
  25, 16, 14, 17, 17, 17,
  40, 59, 94, 140, 180, 192,
  122, 190, 131, 131, 113, 97,
  73, 63, 71, 72, 60, 42
];

// Day multiplier based on GA4
// 0=Sun,1=Mon,2=Tue,3=Wed,4=Thu,5=Fri,6=Sat
const dayMultiplier = {
  0: 0.75, // Sunday
  1: 1.00, // Monday
  2: 1.15, // Tuesday
  3: 1.40, // Wednesday
  4: 1.25, // Thursday
  5: 1.15, // Friday
  6: 0.70  // Saturday
};

  
  // -----------------------------------
  // HELPERS
  // -----------------------------------
  function getStoredData() {
    try {
      return JSON.parse(localStorage.getItem(storageKey));
    } catch (e) {
      return null;
    }
  }

  function setStoredData(data) {
    localStorage.setItem(storageKey, JSON.stringify(data));
  }

  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getRandomDelay() {
    return randomInt(MIN_UPDATE_DELAY_MS, MAX_UPDATE_DELAY_MS);
  }

  function getUKNow() {
  return new Date(
    new Date().toLocaleString("en-US", { timeZone: "Europe/London" })
  );
}

  // -----------------------------------
  // TRAFFIC RANGE BY TIME
  // -----------------------------------
 function getTrafficRange() {

  const ukNow = getUKNow();
const hour = ukNow.getHours();
const day = ukNow.getDay();

  const hourlyAverage = hourlyTraffic[hour];
  const multiplier = dayMultiplier[day];

  const adjustedTraffic = hourlyAverage * multiplier;

  // -----------------------------
  // NEW: GET PRODUCT RANGE
  // -----------------------------
  let rangeStr = popup.dataset.range || "3-10";

if (!rangeStr.includes("-")) {
  rangeStr = "3-10";
}

rangeStr = rangeStr.replace(/\s/g, "");

  let [minRange, maxRange] = rangeStr.split("-").map(Number);

  if (isNaN(minRange) || isNaN(maxRange)) {
    minRange = 3;
    maxRange = 10;
  }

  // -----------------------------
  // NORMALIZE TRAFFIC (0 → 1)
  // Based on peak ~3000 sessions from your data :contentReference[oaicite:0]{index=0}
  // -----------------------------
  const MAX_TRAFFIC = 300; // based on your GA (peak ~190 × multiplier)
const normalized = Math.min(adjustedTraffic / MAX_TRAFFIC, 1);

  // -----------------------------
  // SCALE WITH PRODUCT RANGE
  // -----------------------------
  const min = Math.round(minRange + (maxRange - minRange) * normalized * 0.6);
  const max = Math.round(minRange + (maxRange - minRange) * normalized);

  return {
    min,
    max
  };
}

  // -----------------------------------
  // GET INITIAL COUNT FOR CURRENT TIME SLOT
  // -----------------------------------
  function getInitialViews(now = new Date()) {
    const range = getTrafficRange();
    return randomInt(range.min, range.max);
  }

  // -----------------------------------
  // GET CURRENT TIME SLOT KEY
  // used to detect if user moved from morning -> afternoon etc
  // -----------------------------------
 function getTimeSlotKey(now = new Date()) {
  const ukNow = getUKNow();
  return `${ukNow.getDay()}-${ukNow.getHours()}`;
}

  // -----------------------------------
  // GET / RESET DATA
  // -----------------------------------
  function getViewData() {
    const now = getUKNow();
    const nowMs = now.getTime();
    const currentSlot = getTimeSlotKey(now);
    let storedData = getStoredData();

    // create fresh if none exists
    if (
      !storedData ||
      typeof storedData.views !== 'number' ||
      !storedData.nextUpdateAt ||
      !storedData.slotKey
    ) {
      storedData = {
        views: getInitialViews(now),
        nextUpdateAt: nowMs + getRandomDelay(),
        slotKey: currentSlot
      };
      setStoredData(storedData);
      return storedData;
    }

    // if time slot changed (morning -> afternoon etc), reset inside new slot range
    if (storedData.slotKey !== currentSlot) {
      storedData = {
        views: getInitialViews(now),
        nextUpdateAt: nowMs + getRandomDelay(),
        slotKey: currentSlot
      };
      setStoredData(storedData);
      return storedData;
    }

    return storedData;
  }

  // -----------------------------------
  // UPDATE VIEWS REALISTICALLY
  // only every 5-7 mins
  // only small movement
  // mostly up, sometimes same, rarely down by 1
  // but always stay inside current traffic range
  // -----------------------------------
  function getCurrentViews() {
    const now = getUKNow();
    const nowMs = now.getTime();
    let storedData = getViewData();
    const range = getTrafficRange();

    while (nowMs >= storedData.nextUpdateAt) {
      const current = storedData.views;

      let next = current;
      if (next === current) {
  next += Math.random() < 0.5 ? 1 : 0;
}

      // Weighted realistic movement
      // 60% chance +1
      // 20% chance +2
      // 15% chance same
      // 5% chance -1
      const roll = Math.random();

      if (roll < 0.60) {
        next = current + 1;
      } else if (roll < 0.80) {
        next = current + 2;
      } else if (roll < 0.95) {
        next = current;
      } else {
  next = current;
}

      storedData.views = clamp(next, range.min, range.max);
      storedData.nextUpdateAt += getRandomDelay();
    }

    setStoredData(storedData);
    return storedData.views;
  }

  // -----------------------------------
  // UPDATE POPUP CONTENT
  // -----------------------------------
  function updateContent() {
    const views = getCurrentViews();
    countEl.textContent = views;
  }

  // -----------------------------------
  // SHOW / HIDE POPUP
  // -----------------------------------
  function showPopup() {
    updateContent();
    popup.classList.add('active');

    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(() => {
      popup.classList.remove('active');
    }, 20000);
  }

  closeBtn.addEventListener('click', () => {
    popup.classList.remove('active');
    clearTimeout(hideTimeout);
  });

  // -----------------------------------
  // POPUP TIMING
  // 20s, 30s, 40s, then every 20s after 60s
  // -----------------------------------
  // First popup after 20 seconds
// Show immediately on page load
showPopup();

// Then repeat every 40 seconds
repeatInterval = setInterval(showPopup, 40000);
});